import * as React from "react";
import type { SVGProps } from "react";
const SvgPublish = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M5.72 1.75a3.851 3.851 0 0 0-3.85 3.851v44.11a3.851 3.851 0 0 0 3.85 3.85h38.891v1.75H5.721a5.601 5.601 0 0 1-5.601-5.6V5.6A5.601 5.601 0 0 1 5.72 0H55.27a5.601 5.601 0 0 1 5.6 5.601v40.985h-1.75V5.6a3.851 3.851 0 0 0-3.85-3.851H5.72Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M59.995 15.796h-59v-1.75h59v1.75Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M13.598 8.437a3.15 3.15 0 1 1-6.302 0 3.15 3.15 0 0 1 6.302 0Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M10.447 9.837a1.4 1.4 0 1 0 0-2.801 1.4 1.4 0 0 0 0 2.801Zm0 1.75a3.15 3.15 0 1 0 0-6.301 3.15 3.15 0 0 0 0 6.301Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M23.68 8.437a3.15 3.15 0 1 1-6.302 0 3.15 3.15 0 0 1 6.302 0Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M20.53 9.837a1.4 1.4 0 1 0 0-2.801 1.4 1.4 0 0 0 0 2.801Zm0 1.75a3.15 3.15 0 1 0-.001-6.301 3.15 3.15 0 0 0 0 6.301Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M33.762 8.437a3.15 3.15 0 1 1-6.302 0 3.15 3.15 0 0 1 6.302 0Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M30.611 9.837a1.4 1.4 0 1 0 0-2.801 1.4 1.4 0 0 0 0 2.801Zm0 1.75a3.15 3.15 0 1 0 0-6.301 3.15 3.15 0 0 0 0 6.301Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M63.88 49.08c0 7.83-6.348 14.178-14.178 14.178-7.83 0-14.178-6.347-14.178-14.178 0-7.83 6.348-14.178 14.178-14.178 7.83 0 14.178 6.348 14.178 14.178Z"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M49.702 61.508c6.864 0 12.428-5.564 12.428-12.428 0-6.863-5.564-12.428-12.428-12.428-6.864 0-12.428 5.565-12.428 12.428 0 6.864 5.564 12.428 12.428 12.428Zm0 1.75c7.83 0 14.178-6.347 14.178-14.178 0-7.83-6.348-14.178-14.178-14.178-7.83 0-14.178 6.348-14.178 14.178 0 7.83 6.348 14.178 14.178 14.178Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M49.797 41.087a.125.125 0 0 0-.19 0l-5.865 6.867a.115.115 0 0 0-.031.064.133.133 0 0 0 .013.07c.012.026.029.044.044.055a.115.115 0 0 0 .07.017h1.904c1.036 0 1.875.84 1.875 1.876v6.551c0 .07.056.125.125.125h4.343a.125.125 0 0 0 .125-.125v-6.552c0-1.035.84-1.874 1.875-1.874h1.482c.037 0 .057-.01.069-.018a.132.132 0 0 0 .045-.055.134.134 0 0 0 .013-.07.115.115 0 0 0-.032-.064l-5.865-6.867Zm-1.52-1.137a1.875 1.875 0 0 1 2.851 0l5.865 6.868c1.04 1.217.175 3.093-1.426 3.093h-1.482a.125.125 0 0 0-.125.124v6.552c0 1.036-.84 1.875-1.875 1.875h-4.343a1.875 1.875 0 0 1-1.875-1.875v-6.552a.125.125 0 0 0-.125-.124h-1.905c-1.6 0-2.465-1.876-1.426-3.093l5.865-6.867Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M36.638 21.741c0-.69.56-1.25 1.25-1.25h16.5a1.25 1.25 0 0 1 0 2.5h-16.5c-.69 0-1.25-.56-1.25-1.25ZM36.638 26.241c0-.69.56-1.25 1.25-1.25h16.5a1.25 1.25 0 0 1 0 2.5h-16.5c-.69 0-1.25-.56-1.25-1.25ZM36.638 30.741c0-.69.56-1.25 1.25-1.25h6.201a1.25 1.25 0 1 1 0 2.5h-6.2c-.691 0-1.25-.56-1.25-1.25ZM8.995 39.878c0-.69.56-1.25 1.25-1.25h20.5a1.25 1.25 0 0 1 0 2.5h-20.5c-.69 0-1.25-.56-1.25-1.25ZM8.995 44.378c0-.69.56-1.25 1.25-1.25h20.5a1.25 1.25 0 0 1 0 2.5h-20.5c-.69 0-1.25-.56-1.25-1.25Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M28.995 21.34h-17c-.69 0-1.25.559-1.25 1.25v9.312c0 .69.56 1.25 1.25 1.25h17c.69 0 1.25-.56 1.25-1.25V22.59c0-.69-.56-1.25-1.25-1.25Zm-17-1.75a3 3 0 0 0-3 3v9.312a3 3 0 0 0 3 3h17a3 3 0 0 0 3-3V22.59a3 3 0 0 0-3-3h-17Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPublish;
